import { Component, OnInit } from '@angular/core';
import {
  catchError,
  delay,
  map,
  shareReplay,
  switchMap,
  tap
} from 'rxjs/operators';
import { SeasonService } from '../../season.service';
import { RacesService } from '../../races/races.service';
import { combineLatest, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RankingsService } from '../../rankings/rankings.service';
import { Race } from '../race';
import { RaceRanking } from './race-ranking';
import { AppService } from '../../../app.service';
import { RaceService } from '../race.service';
import { RaceStandingsService } from '../../standings/race-standings.service';
import { Ranking } from '../../rankings/ranking';

@Component({
  selector: 'mc-race-ranking',
  templateUrl: './race-ranking.component.html',
  styleUrls: ['./race-ranking.component.scss']
})
export class RaceRankingComponent implements OnInit {

  race$: Observable<Race> = this.activatedRoute.parent.parent.data.pipe(
    switchMap((data) => data.race$ as Observable<Race>),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  rankings$ = this.rankingsService.rankings$;

  // Ranking from active route or null.
  // Redirects to the general ranking or the first available ranking as a fallback.
  public readonly ranking$: Observable<Ranking> = this.activatedRoute.data.pipe(
    switchMap((data) => data.ranking$ as Observable<Ranking>),
    catchError((error, caught) => this.rankings$.pipe(
      map((rankings) => rankings[0] || null),
      map((firstRanking) => this.router.navigate(
        firstRanking ? ['../', firstRanking.id] : ['../../'],
        {
          replaceUrl: true,
          relativeTo: this.activatedRoute
        })),
      delay(0),
      switchMap(() => caught)
    )),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  raceRanking$: Observable<RaceRanking> = combineLatest([
    this.race$,
    this.ranking$
  ]).pipe(
    map(([race, ranking]) => this.raceStandingsService.createRaceRanking(race, ranking)),
    tap((raceRanking) => this.appService.fixView()),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  constructor(
    private readonly appService: AppService,
    private readonly route: ActivatedRoute,
    private readonly raceService: RaceService,
    private readonly raceStandingsService: RaceStandingsService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly seasonService: SeasonService,
    private readonly racesService: RacesService,
    private readonly rankingsService: RankingsService
  ) { }

  ngOnInit() {
  }
}
